export default {"src":"/_next/static/media/favicon.32c88096.ico","height":150,"width":150,"blurWidth":0,"blurHeight":0};